import { useState } from "react";
import { useApi } from "../hooks/useApi";
import { api } from "../lib/api";
import { AdTile } from "../components/AdTile";

export function ExplorePage() {
  const explore = useApi(api.explore, []);
  const [selected, setSelected] = useState<string | null>(null);
  const post = explore.data?.posts.find((item) => item.id === selected);
  return (
    <section className="page-slab">
      <header className="page-head"><h1>Explore</h1><input placeholder="Search culture, people, hashtags" onFocus={() => location.assign("/search")} /></header>
      <div className="topic-row"><button>#lagoon</button><button>#terminalone</button><button>#government</button><button>#fashion</button></div>
      <div className="masonry">
        {explore.data?.posts.map((item, index) => (
          <button className={index % 5 === 0 ? "tile tall" : "tile"} key={item.id} onClick={() => setSelected(item.id)}>
            {item.media[0] ? <img src={item.media[0].url} alt={item.media[0].altText} /> : <span>{item.caption}</span>}
          </button>
        ))}
        {explore.data?.ads.map((ad) => <AdTile ad={ad} compact key={ad.id} />)}
      </div>
      {post && <div className="modal-backdrop" onClick={() => setSelected(null)}><article className="post-lightbox" onClick={(event) => event.stopPropagation()}><img src={post.media[0]?.url} alt="" /><div><h2>{post.author.displayName}</h2><p>{post.caption}</p><a href={`/p/${post.id}`}>Open post</a></div></article></div>}
    </section>
  );
}
